import {
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpCacheService } from './http-cache.service';
import { HTTP_CACHE_POLICY_CONFIG } from './http-cache-policy-config.const';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

export const httpCacheInterceptor: HttpInterceptorFn = (req, next) => {
  const httpCacheService = inject(HttpCacheService);

  if (req.method !== 'GET') {
    return next(req);
  }

  const policyConfig = HTTP_CACHE_POLICY_CONFIG.find(p =>
    typeof p.endpoint === 'string'
      ? req.url.includes(p.endpoint)
      : p.endpoint.test(req.url)
  );

  if (!policyConfig) {
    return next(req);
  }

  const cacheKey = policyConfig.cacheKey;
  const cached = httpCacheService.get(
    cacheKey,
    req.urlWithParams,
    policyConfig.cacheType
  );

  if (cached !== null) {
    return of(new HttpResponse({ body: cached, status: 200 }));
  }

  return next(req).pipe(
    tap(response => {
      if (response instanceof HttpResponse) {
        httpCacheService.set(
          cacheKey,
          req.urlWithParams,
          response.body,
          policyConfig.cacheType
        );
      }
    })
  );
};
